(function(){

(function(){
   
  var mq=document.getElementById('mq'); mq.innerHTML+=mq.innerHTML;

   
  (function(){
    var svg=document.getElementById('barcode'),x=0,seed=7;
    while(x<196){
      var w=((seed=seed*16807%2147483647)%3)+1;
      var gap=((seed=seed*16807%2147483647)%3)+1;
      var r=document.createElementNS('http://www.w3.org/2000/svg','rect');
      r.setAttribute('x',x);r.setAttribute('y',0);r.setAttribute('width',w);r.setAttribute('height',44);r.setAttribute('fill','#111');
      svg.appendChild(r); x+=w+gap;
    }
  })();

   
  var AC=null,soundOn=false;
  function ctx(){ if(!AC) AC=new (window.AudioContext||window.webkitAudioContext)(); if(AC.state==='suspended')AC.resume(); return AC; }
  function env(g,t,a,d){g.gain.setValueAtTime(0,t);g.gain.linearRampToValueAtTime(a,t+.01);g.gain.exponentialRampToValueAtTime(.001,t+d)}
  function boing(){ if(!soundOn)return; var c=ctx(),o=c.createOscillator(),g=c.createGain(),t=c.currentTime;
    o.type='sine';o.frequency.setValueAtTime(500,t);o.frequency.exponentialRampToValueAtTime(120,t+.25);
    env(g,t,.16,.3);o.connect(g).connect(c.destination);o.start(t);o.stop(t+.35);}
  function pop(){ if(!soundOn)return; var c=ctx(),o=c.createOscillator(),g=c.createGain(),t=c.currentTime;
    o.type='sine';o.frequency.setValueAtTime(880,t);o.frequency.exponentialRampToValueAtTime(1500,t+.06);
    env(g,t,.08,.12);o.connect(g).connect(c.destination);o.start(t);o.stop(t+.15);}
   
  var baaPool=[],baaIdx=0;
  for(var _b=0;_b<4;_b++){var _a=new Audio((__RD_IMPACT_ASSETS_BASE__+'redesign-impact-sheep-baa.mp3'));_a.preload='auto';_a.volume=.28;baaPool.push(_a);}
  function baa(){ if(!soundOn)return; var a=baaPool[baaIdx]; baaIdx=(baaIdx+1)%baaPool.length;
    try{a.currentTime=0;var p=a.play();if(p&&p.catch)p.catch(function(){});}catch(e){} }
  function tada(){ if(!soundOn)return; var c=ctx(),t=c.currentTime;
    [523,659,784,1047].forEach(function(f,i){var o=c.createOscillator(),g=c.createGain();
      o.type='triangle';o.frequency.value=f;env(g,t+i*.08,.16,.5);
      o.connect(g).connect(c.destination);o.start(t+i*.08);o.stop(t+i*.08+.55);});}

  var sb=document.getElementById('soundbtn'),lbl=document.getElementById('snd-label'),icon=document.getElementById('snd-icon');
  var iconOff='<polygon points="11,5 6,9 2,9 2,15 6,15 11,19" fill="currentColor" stroke="none"/><line x1="16" y1="9" x2="22" y2="15"/><line x1="22" y1="9" x2="16" y2="15"/>';
  var iconOn='<polygon points="11,5 6,9 2,9 2,15 6,15 11,19" fill="currentColor" stroke="none"/><path d="M15.5 8.5 a5 5 0 0 1 0 7" fill="none"/><path d="M18.5 5.5 a9.5 9.5 0 0 1 0 13" fill="none"/>';
  sb.addEventListener('click',function(){
    soundOn=!soundOn; ctx();
    lbl.textContent=soundOn?'sound: on':'sound: off';
    icon.innerHTML=soundOn?iconOn:iconOff;
    if(soundOn)tada();
  });


   
  if(matchMedia('(pointer:fine)').matches){
    var last=0;
    document.addEventListener('mousemove',function(e){
      var now=Date.now(); if(now-last<80)return; last=now;
      var s=document.createElement('span');
      s.className='trail';
      s.innerHTML='O<sub>2</sub>';
      s.style.color='#ffffff';
      s.style.left=(e.clientX-6)+'px';s.style.top=(e.clientY-8)+'px';
      (document.querySelector('.rd-impact')||document.body).appendChild(s);
      setTimeout(function(){s.remove()},800);
    });
  }

   
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target);} });
  },{threshold:0.15});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});

   
  var rec=document.getElementById('receipt');
  new IntersectionObserver(function(es,obs){
    es.forEach(function(e){ if(e.isIntersecting){ rec.classList.add('on'); setTimeout(tada,2000); obs.disconnect(); } });
  },{threshold:0.4}).observe(rec);

   
  document.querySelectorAll('.cutout').forEach(function(el){
    var sx,sy,ox,oy,dragging=false,moved=false;
    el.addEventListener('pointerdown',function(e){
      dragging=true; moved=false; el.setPointerCapture(e.pointerId);
      sx=e.clientX; sy=e.clientY;
      var m=(el.dataset.dx||'0,0').split(','); ox=+m[0]; oy=+m[1];
      el.classList.remove('wobble','wobble2');
      el.style.zIndex=50;
      e.preventDefault();
    });
    el.addEventListener('pointermove',function(e){
      if(!dragging)return;
      var dx=ox+e.clientX-sx, dy=oy+e.clientY-sy;
      if(Math.abs(e.clientX-sx)+Math.abs(e.clientY-sy)>6)moved=true;
      el.dataset.dx=dx+','+dy;
      el.style.transform='translate('+dx+'px,'+dy+'px) rotate(var(--r,0deg))';
    });
    el.addEventListener('pointerup',function(){
      dragging=false;
      if(!moved && el.hasAttribute('data-baa')){
        baa();
        var _im=el.querySelector('img'); if(_im) showItemPop(_im.getAttribute('src'));
        var m=(el.dataset.dx||'0,0').split(',');
        el.style.transition='transform .6s cubic-bezier(.2,2,.4,1)';
        el.style.transform='translate('+m[0]+'px,'+m[1]+'px) rotate(calc(var(--r,0deg) + '+(Math.random()>.5?360:-360)+'deg)) scale(1.2)';
        setTimeout(function(){
          el.style.transform='translate('+m[0]+'px,'+m[1]+'px) rotate(var(--r,0deg))';
          setTimeout(function(){el.style.transition=''},650);
        },650);
      }
    });
  });

   
  var facts=[
    "our regenerative wool sequesters −14kg of CO₂e per kg. an average UK farm emits +20 to 30kg. you do the maths.",
    "our factory runs on 100% solar power. the sun works for free.",
    "every sheep gets 1+ acre of pasture. that's bigger than most apartments.",
    "only the top 1% of farms worldwide meet the ZQ welfare standard. ours do.",
    "zero synthetics = zero microplastics. your sweater will never become glitter in the ocean.",
    "every knit is guaranteed for life. the most sustainable garment is the one that stays in use.",
    "a slice of our profits funds radical farming experiments. soil is the new black.",
    "mulesing? strictly prohibited. always. no exceptions. next question.",
    "cover cropping + no-till + composting + buffer strips = land that gets healthier every year.",
    "validated by Toitū Envirocare to ISO 14064-1:2006. we invited the auditors ourselves."
  ];
  var popup=document.getElementById('fact-popup'),txt=document.getElementById('fact-text'),idx=document.getElementById('fact-idx');
  document.getElementById('factbtn').addEventListener('click',function(){
    var i=Math.floor(Math.random()*facts.length);
    idx.textContent='impact fact no. '+(i+1)+' / '+facts.length;
    txt.textContent=facts[i];
    popup.classList.add('open'); baa();
  });
  document.getElementById('fact-close').addEventListener('click',function(){popup.classList.remove('open');pop();});
  popup.addEventListener('click',function(e){if(e.target===popup){popup.classList.remove('open');pop();}});

   
  function openPop(kind,text){ idx.textContent=kind; txt.textContent=text; popup.classList.add('open'); }
  function nudge(el){ el.classList.add('clicked'); setTimeout(function(){el.classList.remove('clicked');},520); }

   
  var ITEMPOP={
    'redesign-impact-stickers-web-sheep-earth.png':['sticker fact','Merino wool is fully biodegradable — bury it and it returns to the soil within about a year. Try that with polyester.'],
    'redesign-impact-stickers-web-stay-woolly.png':['bad joke','Stay woolly, friend. It is the only acceptable way to be a little sheepish.'],
    'redesign-impact-stickers-web-no-substitute.png':['sticker fact','No synthetic matches wool for temperature regulation — warm when it is cold, cool when it is warm. Nature: still undefeated.'],
    'redesign-impact-stickers-web-grass-fed.png':['sticker fact','Grass-fed fibres. Our wool eats better than most humans — 100% pasture, zero ultra-processed anything.'],
    'redesign-impact-stickers-web-regenerate-soil.png':['sticker fact','Healthy soil can store more carbon than the atmosphere and all plant life combined. Dirt is quietly doing the heavy lifting.'],
    'redesign-impact-stickers-web-soil-mates.png':['bad joke','Soil mates: when the sheep, the grass and the microbes all swipe right. Honestly, a beautiful love story.'],
    'redesign-impact-stickers-web-sheep-face.png':['sticker fact','Sheep can recognise up to 50 other sheep faces and remember them for years. Better memory than you at a party.'],
    'redesign-impact-stickers-web-grow-wild.png':['sticker fact','Grow wild. Our farms keep vegetative buffer strips so nature can do its unruly, beautiful thing.'],
    'redesign-impact-stickers-web-less-plastic.png':['sticker fact','A single synthetic wash can shed thousands of microplastic fibres. Ours shed exactly zero. More fantastic, indeed.'],
    'redesign-impact-stickers-pasture-perfect.png':['sticker fact','Pasture perfect, and we mean it literally: more than an acre each, open sky, and grass grown without a drop of synthetic anything.'],
    'redesign-impact-stickers-impact-and-commitments.png':['click everything','You clicked the title. Peak "click everything" energy — we respect the commitment.'],
    'redesign-impact-images-lake-hawea-station-sheep-image.jpg':['on the ground','Lake Hāwea Station: thousands of hectares of NZ high country, and one of the first stations to go carbon-positive.'],
    'redesign-impact-images-omarama-station-sheep-image.jpg':['on the ground','Omarama Station sits in the Waitaki Valley — big skies, clean rivers, and merino that basically live in a postcard.'],
    'redesign-impact-images-middlehurst-station-sheep-image.jpg':['on the ground','Middlehurst Station: ZQ-certified, top 1% for welfare. The flock here has a better commute than most of us.'],
    'redesign-impact-images-lake-hawea-station-image-1.jpg':['the stations','Lake Hāwea high country: regenerative grazing here rebuilds the very soil that grows our fibre.'],
    'redesign-impact-images-middlehurst-station-image-1.jpg':['the stations','Middlehurst: an acre each, open skies, ZQ-certified — top 1% of farms worldwide.']
  };
  function showItemPop(src){
    var key=(src||'').split('/').pop().split('?')[0];
    var e=ITEMPOP[key]||['click everything','you found one. we have no notes. well done.'];
    openPop(e[0],e[1]);
  }

   
  var titleEl=document.querySelector('#hero .scrawl-title');
  if(titleEl){ titleEl.classList.add('clickpop');
    titleEl.addEventListener('click',function(){ baa(); nudge(titleEl);
      var im=titleEl.querySelector('img'); if(im) showItemPop(im.getAttribute('src')); });
  }

   
  document.querySelectorAll('.sketch,.split-half').forEach(function(fig){
    fig.classList.add('clickpop');
    fig.addEventListener('click',function(){ baa(); nudge(fig);
      var im=fig.querySelector('img'); if(im) showItemPop(im.getAttribute('src')); });
  });

   
  var FREEDOM=[
    ['freedom 01 · thirst & hunger','Fresh water and open pasture, always on tap. Every hour is happy hour.'],
    ['freedom 02 · discomfort','Natural shelter and room to roam, all year round. A spa, but with better views.'],
    ['freedom 03 · pain & disease','Preventative care, and strictly no mulesing. Ever. Non-negotiable.'],
    ['freedom 04 · behave naturally','Grazing, flocking, the occasional dramatic stampede over absolutely nothing. As sheep intended.'],
    ['freedom 05 · fear & distress','Handled calmly and with care, from start to finish. Low stress, high fluff.']
  ];
  document.querySelectorAll('#welfare .stampcard').forEach(function(card,i){
    card.classList.add('clickpop');
    card.addEventListener('click',function(){ pop(); nudge(card);
      var c=FREEDOM[i]||['the five freedoms','a good life, guaranteed.']; openPop(c[0],c[1]); });
  });

   
  var PROOF=[
    ['the evidence','Multi-year on-farm LCAs mean we measure the same farms year after year — a living assessment, not a one-off photo op.'],
    ['the evidence','Carbon Footprint Ltd. crunches our numbers against a global benchmark. We do not grade our own homework.'],
    ['the evidence','Toitū Envirocare checks our maths against ISO 14064-1. Auditors welcome, always.'],
    ['the evidence','B-Corp status is legally binding and re-earned regularly. It is a commitment, not a badge you buy.']
  ];
  document.querySelectorAll('#proof .proof-item').forEach(function(item,i){
    item.classList.add('clickpop');
    item.addEventListener('click',function(){ pop(); nudge(item);
      var c=PROOF[i]||['the evidence','independently verified.']; openPop(c[0],c[1]); });
  });

   
  document.querySelectorAll('.cta,#factbtn').forEach(function(b){
    b.addEventListener('mouseenter',boing);
  });
})();


/* lazy-load <video data-src> elements once they're near the viewport */
(function(){
  var vids=[].slice.call(document.querySelectorAll('video[data-src]'));
  if(!vids.length) return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting) return;
      var v=entry.target;
      io.unobserve(v);
      v.src=v.dataset.src;
      v.removeAttribute('data-src');
      v.load();
      if(v.dataset.autoplay) v.play().catch(function(){});
    });
  },{rootMargin:'200px 0px'});
  vids.forEach(function(v){ io.observe(v); });
})();
})();
